import en from '@/locales/en.json';
import id from '@/locales/id.json';
import ja from '@/locales/ja.json';
import vi from '@/locales/vi.json';
import { getBrowserLocale } from '@shared/helpers/browser';
import { DEFAULT_LANGUAGE } from '@shared/models/settings';
import { createI18n } from 'vue-i18n';

export const i18n = createI18n({
  locale: getBrowserLocale(),
  fallbackLocale: DEFAULT_LANGUAGE,
  warnHtmlMessage: false, // disable warning HTML in message
  messages: {
    en,
    ja,
    vi,
    id,
  },
});
